<ng-container *ngIf="block && !isCarousel()">
    <div class="container container-general-logos d-flex flex-wrap justify-content-center">
        <ng-container *ngFor="let logo of block">
            <ng-container *ngIf="logo.link">
                <div *ngIf="retriveLink(logo.link).isExternal" class="container-general-logos__container-logo">
                    <a *ngIf="logo.immagine" [href]="retriveLink(logo.link).link" target="_blank">
                        <img loading="lazy" [src]="retriveImg(logo.immagine).imageSrc" [alt]="retriveImg(logo.immagine).imageAlt">
                    </a>
                </div>
                <div *ngIf="!retriveLink(logo.link).isExternal" class="container-general-logos__container-logo">
                    <div class="cursor-pointer" *ngIf="logo.immagine" 
                        [routerLink]="retriveLink(logo.link)">
                        <img loading="lazy" [src]="retriveImg(logo.immagine).imageSrc" [alt]="retriveImg(logo.immagine).imageAlt">
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="!logo.link">
                <div class="container-general-logos__container-logo">
                    <img loading="lazy" *ngIf="logo.immagine" [src]="retriveImg(logo.immagine).imageSrc" [alt]="retriveImg(logo.immagine).imageAlt">
                </div>
            </ng-container>
        </ng-container>
    </div>    
</ng-container>
<ng-container *ngIf="block && isCarousel()">
    <owl-carousel-o id="blocco_logo_carousel" [options]="customOptionsOwl" class="my-2">
        <ng-container *ngFor="let logo of block; let idx = index;">
            <ng-template carouselSlide>
                <ng-container *ngIf="logo.link">
                    <div *ngIf="retriveLink(logo.link).isExternal" class="container-general-logos__container-logo m-auto">
                        <a *ngIf="logo.immagine" [href]="retriveLink(logo.link).link" target="_blank">
                            <img loading="lazy" [src]="retriveImg(logo.immagine).imageSrc" [alt]="retriveImg(logo.immagine).imageAlt">
                        </a>
                    </div>
                    <div *ngIf="!retriveLink(logo.link).isExternal" class="container-general-logos__container-logo m-auto">
                        <div class="cursor-pointer" *ngIf="logo.immagine" [routerLink]="retriveLink(logo.link).link">
                            <img loading="lazy" [src]="retriveImg(logo.immagine).imageSrc" [alt]="retriveImg(logo.immagine).imageAlt">
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="!logo.link">
                    <div class="container-general-logos__container-logo m-auto">
                        <img loading="lazy" *ngIf="logo.immagine" [src]="retriveImg(logo.immagine).imageSrc" [alt]="retriveImg(logo.immagine).imageAlt">
                    </div>
                </ng-container>
            </ng-template>
        </ng-container>
    </owl-carousel-o>
</ng-container>